module.exports = __webpack_public_path__ + "static/media/construction.e4c9a107.jpg";